import {ReactElement, useContext, useState} from "react";
import Alert from "../../../alert";
import {AuthContext} from "../../../../contexts/AuthContext";

export function useLogoutConfirmation(): {requestLogout: () => void, logoutConfirmation: ReactElement | null} {
    const {signOut} = useContext(AuthContext);
    const [showAlert, setShowAlert] = useState(false);

    const logoutConfirmation = showAlert ?
        <Alert onCancelClick={() => setShowAlert(false)} onConfirmClick={() => signOut?.()}
            message="Do you want to logout from your account?" />
        : null;

    return {
        requestLogout: () => setShowAlert(true),
        logoutConfirmation
    };
}
